<template>
    <div class="page">
        <div class="date-select-box">
            <el-date-picker class="date-select" style="width: 150px" type="date" v-model="reportDate" placeholder="请选择日期"
                value-format="yyyy-MM-dd" :picker-options="pickerOptions" @change="dateChange"></el-date-picker>
        </div>

        <div class="no-report" v-if="!hasReport">
            <img src="../assets/images/sleep/no_report.png">
            当日没有睡眠分析报告
        </div>
        <div class="container" v-else>
            <div class="clock-box">
                <img src="../assets/images/sleep/out_circle.png" class="clock-img" />

                <div class="big-circle">
                    <div class="mid-circle">
                        <div class="small-circle">
                            <div>睡眠得分</div>
                            <div>{{ sleepScore }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="time-text">{{ goToBedTime }}-{{ leaveBedTime }}</div>
            <div class="time-box"></div>
            <div class="time">
                <!-- <div v-if="goToBedTime != monitorStartTime">上床时间 {{ goToBedTime }}</div>
                <div v-if="goToBedTime == monitorStartTime">{{ monitorStartTime }} 之前上床</div> -->

                <div>{{ onBedDate }}上床</div>

                <div class="line"></div>
                <!-- <div>入睡时间 {{ asleepTime }}</div> -->
                <div>{{ sleepDate }}入睡</div>
                <div class="line"></div>
                <!-- 
                <div v-if="wakeTime == monitorEndTime">{{ monitorEndTime }} 之后醒来</div>

                <div v-if="leaveBedTime == monitorEndTime && wakeTime != monitorEndTime">醒来时间 {{ wakeTime }}</div> -->
                <div>{{ soberDate }}醒来</div>
                <div v-if="leaveBedTime == monitorEndTime && wakeTime != monitorEndTime" class="line"></div>
                <!-- <div v-if="leaveBedTime == monitorEndTime && wakeTime != monitorEndTime">{{ monitorEndTime }} 之后起床</div> -->
                <div>{{ upBedDate }}起床</div>

                <!-- <div v-if="monitorEndTime != leaveBedTime && wakeTime != monitorEndTime">醒来时间 {{ wakeTime }}</div>
                <div v-if="monitorEndTime != leaveBedTime && wakeTime != monitorEndTime" class="line"></div>
                <div v-if="monitorEndTime != leaveBedTime && wakeTime != monitorEndTime">起床时间 {{ leaveBedTime }}</div> -->
            </div>

            <div class="sleep-card-box">
                <div class="sleep-card">
                    <div class="label">在床</div>
                    <div class="sleep-info-box">
                        <div class="info"><span>{{ totalOnBed.hour }}</span> 小时 <span>{{ totalOnBed.minute }}</span> 分钟
                        </div>
                        <div class="circle"></div>
                    </div>
                </div>
                <div class="sleep-card">
                    <div class="label">清醒</div>
                    <div class="sleep-info-box">
                        <div class="info"><span>{{ sober.hour }}</span> 小时 <span>{{ sober.minute }}</span> 分钟 </div>
                        <div class="circle" style="background: #7ED321;"></div>
                    </div>
                </div>
            </div>
            <div class="sleep-card-box">
                <div class="sleep-card">
                    <div class="label">深睡</div>
                    <div class="sleep-info-box">
                        <div class="info"><span>{{ deepSleep.hour }}</span> 小时 <span>{{ deepSleep.minute }}</span> 分钟
                        </div>
                        <div class="circle"></div>
                    </div>
                </div>
                <div class="sleep-card">
                    <div class="label">浅睡</div>
                    <div class="sleep-info-box">
                        <div class="info"><span>{{ lightSleep.hour }}</span> 小时 <span>{{ lightSleep.minute }}</span> 分钟
                        </div>
                        <div class="circle" style="background: #7ED321;"></div>
                    </div>
                </div>
            </div>
            <div class="sleep-card-box">
                <div class="sleep-card">
                    <div class="label">体动次数</div>
                    <div class="sleep-info-box">
                        <div class="info"><span>{{ bodyMovementNumbers }}</span> 次</div>
                        <div class="circle" style="background: #30C2FF;"></div>
                    </div>
                </div>
                <div class="sleep-card">
                    <div class="label">离床次数</div>
                    <div class="sleep-info-box">
                        <div class="info"><span>{{ leaveBedNumbers }}</span> 次</div>
                        <div class="circle" style="background: #30C2FF;"></div>
                    </div>
                </div>
            </div>

            <div class="chart-title">呼吸折线图</div>
            <div class="chart" id="breatherChart"></div>
            <div class="chart-title">心跳折线图</div>
            <div class="chart" id="heartChart"></div>
            <div class="chart-title">睡眠分期</div>
            <div class="chart" id="sleepChart"></div>
        </div>
    </div>
</template>
<script>
import { sleepReport } from "../api/device";
import utils from '../utils/utils'
import * as echarts from "echarts/core";
import {
    TooltipComponent,
    GridComponent,
    DataZoomComponent,
    MarkAreaComponent,
    VisualMapComponent,
    MarkLineComponent,
    LegendComponent,
} from "echarts/components";
import { LineChart, BarChart, PieChart, CustomChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
echarts.use([
    TooltipComponent,
    GridComponent,
    DataZoomComponent,
    MarkAreaComponent,
    VisualMapComponent,
    LineChart,
    BarChart,
    CanvasRenderer,
    MarkLineComponent,
    LegendComponent,
    PieChart,
    CustomChart
]);

let sleepChart;
export default {
    data() {
        return {
            reportSn: '',
            reportDate: '',
            sleepLoading: false,
            hasReport: true,
            sleepScore: 0,
            goToBedTime: '',
            asleepTime: '',
            wakeTime: '',
            leaveBedTime: '',
            monitorStartTime: '',
            monitorEndTime: '',
            onBedDate: '',
            sleepDate: '',
            soberDate: '',
            upBedDate: '',
            totalOnBed: {},
            sober: {},
            deepSleep: {},
            lightSleep: {},
            bodyMovementNumbers: 0,
            leaveBedNumbers: 0,
            reportDate: '',
            pickerOptions: {
                disabledDate: (time) => {
                    return (
                        time.getTime() >=
                        new Date(new Date().setHours(0, 0, 0, 0)).getTime() ||
                        time.getTime() <
                        new Date(
                            new Date(
                                new Date().setMonth(new Date().getMonth() - 2)
                            ).setHours(0, 0, 0, 0)
                        ).getTime()
                    );
                },
            },
        }
    },
    created() {

    },
    mounted() {
        this.reportSn = this.getQueryString('sn')
        this.reportDate = this.getQueryString('date')
        this.showSleepReport()
    },
    methods: {
        getQueryString(name) {
            let index = window.location.href.indexOf('?');
            let value = window.location.href.slice(index + 1, window.location.href.length)
            let arr = value.split('&');
            let list = [];
            let content = undefined
            if (arr.length > 0) {
                arr.forEach(item => {
                    list.push(item.split('='))
                })
            }

            if (list.length > 0) {
                list.forEach(item => {
                    if (item[0] == name) {
                        content = item[1]
                    }
                })
            }

            return content
        },

        dateChange(e) {
            this.showSleepReport()
        },

        // 睡眠报告
        showSleepReport() {
            this.sleepLoading = true;

            sleepReport({
                reportDate: this.reportDate,
                radarSn: this.reportSn,
            }).then((res) => {
                this.sleepLoading = false;

                if (res.data.sleepQualityInfo.length == 0) {
                    this.hasReport = false
                } else {
                    this.hasReport = true;

                    // 睡眠数据
                    this.sleepScore = res.data.medicineSleepQuality.sleepScore;
                    this.goToBedTime = utils.formatTime(new Date(res.data.medicineSleepQuality.goToBedTime)).split(' ')[1].slice(0, 5);
                    this.leaveBedTime = utils.formatTime(new Date(res.data.medicineSleepQuality.leaveBedTime)).split(' ')[1].slice(0, 5);
                    this.wakeTime = utils.formatTime(new Date(res.data.medicineSleepQuality.wakeTime)).split(' ')[1].slice(0, 5);
                    this.asleepTime = utils.formatTime(new Date(res.data.medicineSleepQuality.asleepTime)).split(' ')[1].slice(0, 5);

                    this.onBedDate = res.data.medicineSleepQuality.onBedDate
                    this.sleepDate = res.data.medicineSleepQuality.sleepDate
                    this.soberDate = res.data.medicineSleepQuality.soberDate
                    this.upBedDate = res.data.medicineSleepQuality.upBedDate

                    // this.goToBedTime = res.data.medicineSleepQuality.goToBedTime.split(' ')[1].slice(0, 5);
                    // this.leaveBedTime = res.data.medicineSleepQuality.leaveBedTime.split(' ')[1].slice(0, 5);
                    // this.wakeTime = res.data.medicineSleepQuality.wakeTime.split(' ')[1].slice(0, 5);
                    // this.asleepTime = res.data.medicineSleepQuality.asleepTime.split(' ')[1].slice(0, 5);

                    this.totalOnBed = {
                        hour: parseInt(res.data.medicineSleepQuality.totalOnBedTime / 3600),
                        minute: parseInt(res.data.medicineSleepQuality.totalOnBedTime / 60 % 60)
                    }
                    this.sober = {
                        hour: parseInt(res.data.medicineSleepQuality.soberTime / 3600),
                        minute: parseInt(res.data.medicineSleepQuality.soberTime / 60 % 60)
                    }
                    this.deepSleep = {
                        hour: parseInt(res.data.medicineSleepQuality.deepSleepTime / 3600),
                        minute: parseInt(res.data.medicineSleepQuality.deepSleepTime / 60 % 60)
                    }
                    this.lightSleep = {
                        hour: parseInt(res.data.medicineSleepQuality.lightSleepTime / 3600),
                        minute: parseInt(res.data.medicineSleepQuality.lightSleepTime / 60 % 60)
                    }

                    this.bodyMovementNumbers = res.data.medicineSleepQuality.bodyMovementNumbers;
                    this.leaveBedNumbers = res.data.medicineSleepQuality.leaveBedNumbers;

                    // 睡眠分期图表
                    let _goToBed = Math.round(new Date(res.data.medicineSleepQuality.goToBedTime));
                    let _leaveBed = Math.round(new Date(res.data.medicineSleepQuality.leaveBedTime))
                    let _sleepQualityVoList = [];

                    res.data.sleepQualityInfo.forEach(item => {
                        let _currTime = Math.round(new Date(item.quaTime))
                        if (_currTime >= _goToBed && _currTime <= _leaveBed) {
                            _sleepQualityVoList.push(item)
                        }
                    })

                    setTimeout(() => {
                        this.sleepQuality(_sleepQualityVoList)
                    }, 0);


                    // 呼吸心跳图表
                    if (res.data.breathAndHeartInfoList.length > 0) {
                        let x = [];
                        let y1 = [];
                        let y2 = [];
                        res.data.breathAndHeartInfoList.forEach((item) => {
                            x.push(`${item.hour}时${item.minute}分`);
                            y1.push(item.respRate);
                            y2.push(item.heartRate);
                        });

                        setTimeout(() => {
                            this.initBreatherChart(x, y1);
                            this.initHeartChart(x, y2);
                        }, 0);


                    }
                }
            }).catch((err) => {
                this.sleepLoading = false;
            });
        },

        sleepQuality(qualityData) {
            var colors = ['#7033FFBF', '#7033FF78', '#7033FF29', '#FDCC418C']; //三种状态的颜色
            var state = ['深睡', '浅睡', '清醒', '离床']; //三种状态
            if (qualityData.length > 0) {
                let _x = [];
                let [_wake, _light, _deep, _leave] = [[], [], [], []]
                qualityData.forEach((item, index) => {
                    _x.push(index)

                    switch (item.sleepQualityResult) {
                        case -1:
                            _leave.push(index)
                            break;
                        case 0:
                            if (item.saveSleepQualityData == -1) {
                                _leave.push(index)
                            } else {
                                _wake.push(index)
                            }
                            break;
                        case 1:
                            _light.push(index)
                            break;
                        case 2:
                            _deep.push(index)
                            break;
                        default:
                            break;
                    }
                })


                let _y = []

                if (_leave.length > 0) {
                    let segList = this.subsettion(_leave)

                    segList.forEach(item => {
                        _y.push({
                            itemStyle: { normal: { color: colors[3] } },//条形颜色
                            name: '离床',
                            value: [3, item[0], item[item.length - 1]]//0,1,2代表y轴的索引，后两位代表x轴数据开始和结束
                        })
                    })
                }
                if (_wake.length > 0) {
                    let segList = this.subsettion(_wake)

                    segList.forEach(item => {
                        _y.push({
                            itemStyle: { normal: { color: colors[2] } },//条形颜色
                            name: '清醒',
                            value: [2, item[0], item[item.length - 1]]//0,1,2代表y轴的索引，后两位代表x轴数据开始和结束
                        })
                    })
                }
                if (_light.length > 0) {
                    let segList = this.subsettion(_light)

                    segList.forEach(item => {
                        _y.push({
                            itemStyle: { normal: { color: colors[1] } },//条形颜色
                            name: '浅睡',
                            value: [1, item[0], item[item.length - 1]]//0,1,2代表y轴的索引，后两位代表x轴数据开始和结束
                        })
                    })
                }
                if (_deep.length > 0) {
                    let segList = this.subsettion(_deep)

                    segList.forEach(item => {
                        _y.push({
                            itemStyle: { normal: { color: colors[0] } },//条形颜色
                            name: '深睡',
                            value: [0, item[0], item[item.length - 1]]//0,1,2代表y轴的索引，后两位代表x轴数据开始和结束
                        })
                    })
                }


                this.initQualityChart(_x, _y, qualityData)
            }
        },

        subsettion(data) {
            let segList = []
            data.forEach((item, index) => {
                var currentNumber = Number(item)
                // 第一个数
                if (index == 0) {
                    segList.push([])
                    segList[segList.length - 1].push(currentNumber)

                    return;
                }
                // 前一个数索引
                var preIndex = index - 1;
                var preNumber = Number(data[preIndex]);
                if (preNumber + 1 == currentNumber) {
                    segList[segList.length - 1].push(currentNumber)
                } else {
                    segList.push([])
                    segList[segList.length - 1].push(currentNumber)
                }
            });

            return segList
        },

        initQualityChart(_x, _y, origin) {
            _x = _x ? _x : [];
            _y = _y ? _y : []

            var chartDom = document.getElementById('sleepChart');
            var myChart = echarts.init(chartDom);


            var colors = ['#7033FFBF', '#7033FF78', '#7033FF29', '#FDCC418C']; //三种状态的颜色
            var state = ['深睡', '浅睡', '清醒', '离床']; //三种状态

            // echart配置
            var option = {
                color: colors,
                tooltip: {//提示框
                    // trigger: "axis",
                    formatter: function (params) {
                        return params.name + ':' + origin[params.value[1]].quaTime.split(' ')[1] + '~' + origin[params.value[2]].quaTime.split(' ')[1];
                    },//数据的值
                    confine: true
                },
                legend: {//图例
                    data: state,
                    selectedMode: false, // 图例设为不可点击
                    textStyle: {
                        color: '#352C5D'
                    },
                    icon: 'circle',
                    align: 'right',
                    itemWidth: 6,
                    itemHeight: 6
                },
                grid: {//绘图网格
                    left: '3%',
                    right: '3%',
                    top: 30,
                    bottom: 10,
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    splitLine: { show: false },
                    // data: [1, 2, 3, 4, 5, 6, 7, 8, 9],
                    data: _x,
                    axisLine: {
                        lineStyle: {
                            color: "#ABA3CF",
                        },
                    },
                    axisLabel: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                yAxis: {
                    data: ['深睡', '浅睡', '清醒', '离床'],
                    // type: 'value',
                    axisLabel: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#ABA3CF",
                        },
                        show: true
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    }
                },
                dataZoom: {
                    type: "inside",
                    minSpan: 30
                },
                series: [
                    // 用空bar来显示三个图例
                    { name: state[0], type: 'bar', data: [] },
                    { name: state[1], type: 'bar', data: [] },
                    { name: state[2], type: 'bar', data: [] },
                    { name: state[3], type: 'bar', data: [] },
                    {
                        type: 'custom',
                        renderItem: function (params, api) {//开发者自定义的图形元素渲染逻辑，是通过书写 renderItem 函数实现的
                            var categoryIndex = api.value(0);//这里使用 api.value(0) 取出当前 dataItem 中第一个维度的数值。
                            var start = api.coord([api.value(1), categoryIndex]); // 这里使用 api.coord(...) 将数值在当前坐标系中转换成为屏幕上的点的像素值。
                            var end = api.coord([api.value(2), categoryIndex]);
                            var height = api.size([0, 1])[1];

                            return {
                                type: 'rect',// 表示这个图形元素是矩形。还可以是 'circle', 'sector', 'polygon' 等等。
                                shape: echarts.graphic.clipRectByRect({ // 矩形的位置和大小。
                                    x: start[0],
                                    y: start[1] - height / 2,
                                    width: end[0] - start[0] + 1,
                                    height: height
                                }, { // 当前坐标系的包围盒。
                                    x: params.coordSys.x,
                                    y: params.coordSys.y,
                                    width: params.coordSys.width,
                                    height: params.coordSys.height
                                }),
                                style: api.style()
                            };
                        },
                        encode: {
                            x: [1, 2], // data 中『维度1』和『维度2』对应到 X 轴
                            y: 0// data 中『维度0』对应到 Y 轴
                        },
                        data: _y
                    }
                ]
            };

            option && myChart.setOption(option);
        },

        initBreatherChart(x, y) {
            var chartDom = document.getElementById('breatherChart');
            var myChart = echarts.init(chartDom);
            let option;

            option = {
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: x,
                    /* axisLabel: {
                      interval: this.data.typeIndex == 1 ? 0 : 5
                    }, */
                    axisLine: {
                        lineStyle: {
                            color: "#ABA3CF",
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                },
                tooltip: {
                    trigger: "axis",
                    confine: true
                },
                yAxis: {
                    min: 0,
                    max: 40,
                    type: "value",
                    axisLine: {
                        lineStyle: {
                            color: "#ABA3CF",
                        },
                        show: true
                    },
                    splitLine: {
                        lineStyle: {
                            // color: "#ABA3CF",
                        },
                    },
                    scale: true
                },
                grid: {
                    top: 10,
                    bottom: 20,
                    left: 30,
                    right: 20,
                },
                dataZoom: {
                    type: "inside",
                    minValueSpan: 10,
                },
                series: [
                    {
                        data: y,
                        type: "line",
                        lineStyle: {
                            color: "#ABA3CF",
                        },
                        itemStyle: {
                            color: '#ABA3CF'
                        },
                        // areaStyle: {
                        //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        //     {
                        //       offset: 0,
                        //       color: "#FF9800",
                        //     },
                        //     {
                        //       offset: 1,
                        //       color: "#FFFFFF",
                        //     },
                        //   ]),
                        // },
                        // smooth: true,
                        symbol: "none",
                    },
                ],
            };

            option && myChart.setOption(option);
        },

        initHeartChart(x, y) {
            var chartDom = document.getElementById('heartChart');
            var myChart = echarts.init(chartDom);
            let option;

            option = {
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: x,
                    /* axisLabel: {
                      interval: this.data.typeIndex == 1 ? 0 : 5
                    }, */
                    axisLine: {
                        lineStyle: {
                            color: "#ABA3CF",
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                },
                tooltip: {
                    trigger: "axis",
                    confine: true
                },
                yAxis: {
                    min: 50,
                    max: 120,
                    type: "value",
                    axisLine: {
                        lineStyle: {
                            color: "#ABA3CF",
                        },
                        show: true
                    },
                    splitLine: {
                        lineStyle: {
                            // color: "#ABA3CF",
                        },
                    },
                    scale: true
                },
                grid: {
                    top: 10,
                    bottom: 20,
                    left: 30,
                    right: 20,
                },
                dataZoom: {
                    type: "inside",
                    minValueSpan: 10,
                },
                series: [
                    {
                        data: y,
                        type: "line",
                        lineStyle: {
                            color: "#ABA3CF",
                        },
                        itemStyle: {
                            color: '#ABA3CF'
                        },
                        // areaStyle: {
                        //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        //     {
                        //       offset: 0,
                        //       color: "#FF9800",
                        //     },
                        //     {
                        //       offset: 1,
                        //       color: "#FFFFFF",
                        //     },
                        //   ]),
                        // },
                        // smooth: true,
                        symbol: "none",
                    },
                ],
            };

            option && myChart.setOption(option);
        },
    }
}
</script>
<style scoped lang="less">
.page {
    width: 100%;
    height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
    color: #352C5D;

    .no-report {
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: hidden;
        color: #aba3cf;
        font-size: 15px;

        img {
            width: 266px;
            height: 169px;
            margin-top: 150px;
        }
    }

    .container {
        padding: 15px;
        box-sizing: border-box;

        .clock-box {
            width: 242px;
            height: 242px;
            margin: 0 auto;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;

            .clock-img {
                width: 242px;
                height: 242px;
                position: absolute;
                top: 0;
                left: 0;
            }

            .circle-box {
                width: 192px;
                height: 192px;
                position: relative;
                overflow: hidden;
            }

            .big-circle {
                width: 192px;
                height: 192px;
                border-radius: 100%;
                overflow: hidden;
                display: flex;
                justify-content: center;
                align-items: center;
                background: #F6F5FA;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);

                .mid-circle {
                    width: 144px;
                    height: 144px;
                    border-radius: 100%;
                    box-shadow: 0 20px 40px #7033FF66;
                    overflow: hidden;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: #FFFFFF;

                    .small-circle {
                        width: 106px;
                        height: 106px;
                        border-radius: 100%;
                        box-shadow: 0 20px 40px #7033FF66;
                        overflow: hidden;
                        background: #FFFFFF;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;

                        div:first-child {
                            font-size: 12px;
                        }

                        div:nth-child(2) {
                            font-size: 32px;
                            font-weight: bolder;

                            span {
                                font-size: 9px;
                            }
                        }
                    }
                }
            }
        }

        .time-text {
            font-size: 18px;
            font-weight: 700;
            margin-top: 5px;
        }

        .time-box {
            height: 15px;
            border-radius: 15px;
            background: #FB8F66;
            opacity: .16;
        }

        .time {
            height: 7.5px;
            display: flex;
            align-items: center;
            font-size: 10px;
            color: #FB8F66;
            margin-top: 6.5px;
            margin-bottom: 15px;

            div {
                flex: 1;
                text-align: center;
            }

            div:last-child {
                border: none;
            }

            .line {
                width: 2px;
                max-width: 2px;
                height: 7.5px;
                background: #FB8F66;
                border-radius: 2px;
                opacity: .16;
            }
        }

        .sleep-card-box {
            display: flex;
            margin-bottom: 10px;

            .sleep-card {
                flex: 1;
                height: 83px;
                border-radius: 20px;
                background: #F6F5FA;
                box-sizing: border-box;
                padding: 15px 25px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .label {
                    font-size: 12px;
                    color: #352C5D;
                }

                .sleep-info-box {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;
                    font-size: 10px;
                    color: #352C5D;

                    span {
                        font-size: 18px;
                        font-weight: 700;
                        // margin-right: 10rpx;
                    }

                    .circle {
                        width: 6px;
                        height: 6px;
                        border-radius: 6px;
                        background: #FB8F66;
                    }
                }
            }

            .sleep-card:first-child {
                margin-right: 15px;
            }
        }

        .chart-title {
            font-size: 15px;
            font-weight: bolder;
            margin: 10px 0;
        }

        .chart {
            width: 100%;
            height: 200px;
        }

        .sleep-score {
            padding: 20rpx;
            margin: 30px 0 20px;
            border-radius: 20px;
            background: linear-gradient(to bottom, #F6F5FA, #FFFFFF);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
    }

    .date-select-box {
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }
}
</style>
<style>
.date-select>input {
    width: 150px;
    border: none;
    text-align: center;
    margin-left: auto;
}

.date-select>span {
    display: none;
}
</style>


// WEBPACK FOOTER //
// src/views/reportMobile.vue